"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mapInitialStateToStoreState_1 = __importDefault(require("../utils/store/mapInitialStateToStoreState"));
/**
 * Quote ID Expiry Domain Store
 */
class QuoteExpiryStore {
    constructor(initialState) {
        this.quoteExpired = false;
        this.timer = null;
        /**
         * Initialize session expiry
         * @param {number} expiry in mins
         */
        this.initializeSession = (expiry) => {
            console.log('*** quote ID expiry initialized');
            this.quoteExpired = false;
            // clear existing timer
            if (this.timer) {
                clearTimeout(this.timer);
            }
            // start a timer
            this.timer = setTimeout(() => {
                this.onExpiry();
            }, expiry * 60 * 1000); // convert to ms
        };
        /**
         * Action to update the quoteExpired
         * observable
         */
        this.onExpiry = () => {
            console.log('*** quote ID expired');
            this.quoteExpired = true;
        };
        /**
         * Action to set quote expiry explicitly
         * @param {boolean} expiry
         */
        this.setExpiry = (expiry = false) => {
            this.quoteExpired = expiry;
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.updateInitialState(initialState);
    }
}
__decorate([
    mobx_1.observable
], QuoteExpiryStore.prototype, "quoteExpired", void 0);
__decorate([
    mobx_1.action.bound
], QuoteExpiryStore.prototype, "onExpiry", void 0);
__decorate([
    mobx_1.action.bound
], QuoteExpiryStore.prototype, "setExpiry", void 0);
__decorate([
    mobx_1.action.bound
], QuoteExpiryStore.prototype, "updateInitialState", void 0);
exports.default = QuoteExpiryStore;
